var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"header"},[_c('span',{staticClass:"head",on:{"click":_vm.yearMin}},[_c('i',{staticClass:"el-icon-d-arrow-left"})]),_c('span',{staticClass:"year"},[_vm._v(_vm._s(_vm.year-1)+"-"+_vm._s(_vm.year)+" 学年")]),_c('span',{staticClass:"head",on:{"click":_vm.yearPlus}},[_c('i',{staticClass:"el-icon-d-arrow-right"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }